import { render, staticRenderFns } from "./OldhamCity.vue?vue&type=template&id=7ba10777&scoped=true&"
import script from "./OldhamCity.vue?vue&type=script&lang=js&"
export * from "./OldhamCity.vue?vue&type=script&lang=js&"
import style0 from "./OldhamCity.vue?vue&type=style&index=0&id=7ba10777&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba10777",
  null
  
)

export default component.exports